import React from 'react';
import { useTranslation } from 'react-i18next';
import useSeo from '../hooks/useSeo';
import { usePageContent } from './home/pageContent';
import { BoxGrid, CardStack, FeatureIcon, PageHero, PageShell, SectionIntro, ShowcaseCard } from './home/blocks';
import CtaBanner from './home/CtaBanner';

/* Figma "Functionaliteiten" frame (node 35748:358). Content: Admin → Landingspagina → Functies. */
const FunctionaliteitenPagina = () => {
  const { t } = useTranslation();
  const { lang, cms, content } = usePageContent('features');

  useSeo({
    path: '/functionaliteiten',
    lang,
    title: cms?.seo?.title || t('features_page.seo_title'),
    description: cms?.seo?.description || t('features_page.seo_description'),
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: t('features_page.title'),
      itemListElement: content.cards.map((c, i) => ({ '@type': 'ListItem', position: i + 1, name: c.title, description: c.body })),
    },
  });

  return (
    <PageShell testId="functionaliteiten-page">
      <PageHero hero={content.hero} />
      <SectionIntro title={content.intro.title} />
      <CardStack>
        {content.cards.map((card, i) => (
          <ShowcaseCard key={i} id={`functie-${i + 1}`} card={card} index={i} icon={<FeatureIcon icon={card.icon} />} />
        ))}
      </CardStack>
      <BoxGrid id="meer" title={content.boxes.title} items={content.boxes.items} />
      <div className="pt-[clamp(0px,5.3333vw,96px)]">
        <CtaBanner cta={content.cta} wide />
      </div>
    </PageShell>
  );
};

export default FunctionaliteitenPagina;
